import {
  PRODUCT_TRANSACTION_RETURN_ALL,
  PRODUCT_TRANSACTION_RETURN_GET,
  PRODUCT_TRANSACTION_RETURN_DEL,
  PRODUCT_TRANSACTION_RETURN_PUT,
  PRODUCT_TRANSACTION_RETURN_POST,
  PRODUCT_TRANSACTION_RETURN_LOADING,
  PRODUCT_TRANSACTION_RETURN_ERROR,
  PRODUCT_TRANSACTION_RETURN_RESET,
  PRODUCT_TRANSACTION_RETURN_EXCEL_SUCCESS
} from '../types';

import api from '../../../utils/functions/api';

export const productTransactionReturnCreate = (payload) => async (dispatch) => {
  try {
    console.log('payload in product transaction', payload);
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/product-transaction-return`,
      {
        ...payload,
      },
    );
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_ERROR });
    throw new Error(error);
  }
};
export const productTransactionAllExcel = (params) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_LOADING });

    const {
      name = '',
      transactionType = '',
      startDate = '',
      endDate = '',
      selectDate = '',
      selectBrand = ''
    } = params;

    const response = await api.post(
      `${process.env.REACT_APP_API_URL}/product-transaction-return/export-all`,
      {
        name,
        type: transactionType,
        startDate,
        endDate,
        selectDate,
        selectBrand: selectBrand?._id || ''
      },
      {
        responseType: 'blob',
        timeout: 180000
      }
    );

    // Create blob from response
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    // Create download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    // Generate filename with timestamp
    const timestamp = new Date().toISOString().split('T')[0];
    link.download = `รายงานรับคืนสินค้า_${timestamp}.xlsx`;

    // Trigger download
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);

    dispatch({ type: PRODUCT_TRANSACTION_RETURN_EXCEL_SUCCESS });

  } catch (error) {
    console.error('Export Excel Error:', error);
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_ERROR });
    throw new Error('ไม่สามารถดาวน์โหลดไฟล์ Excel ได้');
  }
};

export const productTransactionReturnAll = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = '',
      page = 1,
      transactionType = '',
      startDate = '',
      endDate = '',
      DashBoardDaily = '',
      DashBoardPage = false,
      selectDate = '',
      selectBrand = '',
    } = params;

    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product-transaction-return?name=${name}&size=${size}&page=${page}&type=${transactionType}&startDate=${startDate}&endDate=${endDate}&DashBoardDaily=${DashBoardDaily}&DashBoardPage=${DashBoardPage}&selectDate=${selectDate}&selectBrand=${selectBrand}`,
    );
    if (status === 200) {
      dispatch({ type: PRODUCT_TRANSACTION_RETURN_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_ERROR });
    throw new Error(error);
  }
};

export const productTransactionReturnReset = () => async (dispatch) => {
  try {
    const data = [];
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_RESET, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_ERROR });
    throw new Error(error);
  }
};

export const productTransactionReturnGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product-transaction-return/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PRODUCT_TRANSACTION_RETURN_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_ERROR });
    throw new Error(error);
  }
};

export const productTransactionReturnUpdateStock = (payload) => async (
  dispatch,
) => {
  try {
    console.log(
      'payload in product productTransactionReturnUpdateStock',
      payload,
    );
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/product-transaction-return/update-stock`,
      {
        ...payload,
      },
    );
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_GET, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_ERROR });
    throw new Error(error);
  }
};

export const productTransactionReturnPut = (id, payload) => async (
  dispatch,
) => {
  try {
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/product-transaction-return/${id}`,
      payload,
    );
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_ERROR });
    throw new Error(error);
  }
};
export const productTransactionReturnDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/product-transaction-return/${id}`,
    );
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_RETURN_ERROR });
    throw new Error(error);
  }
};
